import React, { useState, useContext, useEffect } from "react";
import { Card, Typography, Button, Radio, Divider, message } from "antd";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const { Title, Text } = Typography;

export default function SelfAssessment() {
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const { authData, backUrl } = useContext(AuthContext);
  const [data, setData] = useState(null)

  // ✅ Fetch questions
  const fetchQuestions = async () => {
    try {
      const res = await axios.get(`${backUrl}/api/appraisal/my-appraisal/`, {
        headers: {
          Authorization: `Bearer ${authData?.access}`,
        },
      });

      const data = res.data?.employee_answers || [];
      setQuestions(data);
      setData(res.data)
      console.log("Questions:", data);
    } catch (error) {
      console.error("Error fetching questions:", error);
      message.error("Failed to fetch questions");
    }
  };

  useEffect(() => {
    fetchQuestions();
  }, []);

  // ✅ Group by section
  const grouped = questions.reduce((acc, item) => { 
    const section = item.question?.section || "General";
    if (!acc[section]) acc[section] = [];
    acc[section].push(item);
    return acc;
  }, {});

  // ✅ Handle selection
  const handleSelect = (answerId, value) => {
    setAnswers((prev) => ({ ...prev, [answerId]: value }));
  };

  // ✅ Submit answers
  const handleSubmit = async () => {
    if (Object.keys(answers).length !== questions.length) {
      toast.warn("⚠️ Please answer all questions before submitting.", {
        position: "top-center",
      });
      return;
    }

    // Build correct payload
    const payload = {
      answers: questions.map((item) => ({
        answer_id: item.id, // ✅ This is the main answer id (e.g., 101)
        chosen_option_id: answers[item.id], // ✅ Selected option ID
        remarks: "", // optional
      })),
    };

    console.log("Final Payload:", payload);

    try {
      await axios.post(
        `${backUrl}/api/appraisal/my-appraisal/${data.id}/submit/`,
        payload,
        {
          headers: { Authorization: `Bearer ${authData?.access}` },
        }
      );

      toast.success("Self-assessment submitted successfully!", {
        position: "top-center",
      });
    } catch (error) {
      console.error("Submit error:", error);
      toast.error("Failed to submit self-assessment.", {
        position: "top-center",
      });
    }
  };

  return (
    <div style={{ padding: "20px 40px" }}>
      <Title level={3} style={{ textAlign: "center", marginBottom: 20 }}>
        Self Assessment Form
      </Title>

      {Object.keys(grouped).map((section, idx) => (
        <Card
          key={idx}
          title={
            <Text strong style={{ fontSize: "16px" }}>
              {section}
            </Text>
          }
          style={{
            marginBottom: 20,
            borderRadius: 12,
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          }}
        >
          {grouped[section].map((item) => (
            <div key={item.id} style={{ marginBottom: 20 }}>
              <Text style={{ fontWeight: 500 }}>
                {item.question.order}. {item.question.text}
              </Text>

              <div style={{ marginTop: 10 }}>
                <Radio.Group
                  onChange={(e) => handleSelect(item.id, e.target.value)}
                  value={answers[item.id]}
                  style={{
                    display: "flex",
                    gap: "25px",
                    flexWrap: "wrap",
                    marginTop: "8px",
                  }}
                >
                  {Array.isArray(item.question.options) &&
                    item.question.options.length > 0 ? (
                    item.question.options.map((opt) => (
                      <Radio key={opt.id} value={opt.id}>
                        {opt.text}
                      </Radio>
                    ))
                  ) : (
                    <Text type="secondary">No options available</Text>
                  )}
                </Radio.Group>
              </div>
            </div>
          ))}
        </Card>
      ))}

      <Divider />

      <div style={{ textAlign: "center", marginTop: 20 }}>
        <Button type="primary" size="large" onClick={handleSubmit}>
          Submit Assessment
        </Button>
      </div>

      <ToastContainer />
    </div>
  );
}
